
  import { mapState } from 'vuex'
  import playGames from '~/mixins/common/play-games'
  import vipSettings from '~/mixins/pages/mission-control/vipSettings'
  import gameMenu from '~/mixins/common/pages/game-menu'
  import cms from '~/mixins/common/cms'

  export default {
    name: 'MenubarComponent',
    mixins: [playGames, vipSettings, gameMenu, cms],
    data: () => ({
      openCard: [],
      v: true,
      expandSubMenu: null,
      selectedMenuItems: null,
      hoveredGameIndex: null
    }),
    computed: {
      ...mapState({
        playGameLoading: state => state.settings.loading,
        menubars: state => state.cms.menus.menus,
        missionSettings: state => state.activities['mission-reward'].missionsSettings,
        missionBadge: state => state.activities['mission-reward'].missionBadge,
        isLogin: state => state.settings.isLogin
      })
    },
    methods: {
      selectedMenu(item, toggle) {
        this.selectedMenuItems = item
        toggle()
      },
      playGameNewTab() {
        this.$nuxt.$emit('openGameNewTab')
      },
      closeMenu() {
        this.expandSubMenu = null
        this.selectedMenuItems = null
      }
    }
  }
